import { Component, OnInit } from '@angular/core';
import { CategoriaInscripcionService } from '../../services/services.index';
import { CategoriaInscripcion } from '../../models/categoriaInscripcion.model';
import { ModalCategInscService } from '../../components/modal-categ-insc/modal-categ-insc.service';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-categoria-inscripcion',
  templateUrl: './categoria-inscripcion.component.html',
  styles: []
})
export class CategoriaInscripcionComponent implements OnInit {

  totalRegistros: number;
  desde: number = 0;
  categoriasInscripcion: CategoriaInscripcion[] = [];
  siguienteDisable: boolean = false;
  anteriorDisable: boolean = true;

  loading: boolean = true;

  constructor(  public _categoriaInscripcionService: CategoriaInscripcionService,
                public _modalCategInscService: ModalCategInscService ) { }

  ngOnInit() {
    this.cargarCategorias();
    this._modalCategInscService.notification.subscribe(resp => {
      this.cargarCategorias();
    });
  }

  buscarCategoria(termino: string) {
    if (termino.length === 0) {
      this.cargarCategorias();
      return;
    }

    this._categoriaInscripcionService.buscarCategoria(termino).subscribe((resp: any) => {
      this.categoriasInscripcion = resp.categoriaInscripcion;
      this.totalRegistros = resp.total;
    });
  }

  cargarCategorias() {
    this.loading = true;
    this._categoriaInscripcionService.getCategoriasInscripcion(this.desde).subscribe((data: any) => {

      this.categoriasInscripcion = data.categoriasInscripcion;
      this.totalRegistros = data.total;

      this.loading = false;

      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + 5) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  siguienteCategorias() {

    this.desde = this.desde + 5;
    this.cargarCategorias();

    if ((this.desde + 5) >= this.totalRegistros) {
      this.siguienteDisable = true;
    }

    if ((this.desde - 5) < 0) {
      this.anteriorDisable = true;
    } else {
      this.anteriorDisable = false;
    }
  }

  anteriorCategorias() {

    this.desde -= 5;
    this.cargarCategorias();

    if ((this.desde - 5) <= 0) {
      this.anteriorDisable = true;
    }
    if ((this.desde + 5) >= this.totalRegistros) {
      this.siguienteDisable = true;
    } else {
      this.siguienteDisable = false;
    }

  }

  borrarCategoria( categoria: CategoriaInscripcion ) {
    this.loading = true;
    this._categoriaInscripcionService.borrarCategoria(categoria).subscribe(resp => {
      swal('Categoria borrada', 'Categoria borrada satisfactoriamente.', 'success');
      this.loading = false;
      this.cargarCategorias();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/categoria-inscripcion/categoria-inscripcion.component.ts